import * as THREE from 'three'

export const front = 'front'
export const top = 'top'
export const right = 'right'
export const bottom = 'bottom'
export const left = 'left'
export const back = 'back'

export const orbit = 'orbit'

const sides = [front, top, right, bottom, left, back] as const
export const views = [...sides, orbit] as const

export default sides

export type Side =
  | typeof front
  | typeof top
  | typeof right
  | typeof bottom
  | typeof left
  | typeof back

type NormalVector3 = readonly [0 | 1 | -1, 0 | 1, 0 | 1]

export const frontNormal = [0, 0, 1] as const
export const topNormal = [0, 1, 0] as const
export const rightNormal = [1, 0, 0] as const
export const bottomNormal = [0, -1, 0] as const
export const leftNormal = [-1, 0, 0] as const
export const backNormal = [0, 0, -1] as const

type SideNormal =
  | typeof frontNormal
  | typeof topNormal
  | typeof rightNormal
  | typeof bottomNormal
  | typeof leftNormal
  | typeof backNormal

/* prettier-ignore */
const fromLeft = [
  0,0,1,0,
  0,1,0,0,
  -1,0,0,0,
  0,0,0,1
]

/* prettier-ignore */
const fromBottom = [
  1, 0, 0, 0,
  0, 0, 1, 0,
  0,-1, 0, 0,
  0, 0, 0, 1
]
